// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1OAuthIntrospectRequestSchema } from './v1/oAuth/introspectRequestSchema';
import { v1OAuthIntrospectResponseSchema } from './v1/oAuth/introspectResponseSchema';

/**
 * @description token introspection result
 */
export const introspectAccessToken200Schema = z.lazy(() => v1OAuthIntrospectResponseSchema);

export const introspectAccessTokenMutationRequestSchema = z.lazy(() => v1OAuthIntrospectRequestSchema);

export const introspectAccessTokenMutationResponseSchema = z.lazy(() => introspectAccessToken200Schema);
